export default from './animated-loader';



// WEBPACK FOOTER //
// ./app/components/animated-loader/index.js